import { levelCap } from "./homeKind";
import { isLevel, isPersonalLevel, lowerOf, reaches, } from "./levels";
import { isBelow, isNenda, placeChain, samePlace, } from "./places";
import { isResourcePath, lookupOrder, RESOURCES, } from "./resources";
import { isRoleName, ROLES } from "./roles";
export function levelAt(user, resource, place, tree) {
    for (const at of placeChain(place, tree)) {
        const grant = user.grants.find((g) => samePlace(g.place, at));
        const answer = grant && grantAnswer(grant, resource);
        if (answer)
            return lowerOf(answer, levelCap(user.kind));
    }
    return "none";
}
export function canAccess(user, needs, place, tree) {
    const list = "resource" in needs ? [needs] : needs;
    return list.length > 0 && list.every((n) => meets(user, n, place, tree));
}
function meets(user, need, place, tree) {
    const { resource, level } = need;
    if (!isResourcePath(resource) || !isLevel(level))
        return false;
    if (reaches(levelAt(user, resource, place, tree), level))
        return true;
    if (level !== "view" || !RESOURCES[resource].visibleFromBelow)
        return false;
    if (place.kind !== "company" || isNenda(place, tree))
        return false;
    return user.grants.some((g) => isBelow(g.place, place, tree) &&
        reaches(levelAt(user, resource, g.place, tree), "view"));
}
export function canAccessGlobal(user, needs, nenda, tree) {
    const list = "resource" in needs ? [needs] : needs;
    return (list.length > 0 &&
        list.every(({ resource, level }) => {
            if (!isResourcePath(resource) || !isLevel(level))
                return false;
            if (reaches(levelAt(user, resource, nenda, tree), level))
                return true;
            if (level !== "view")
                return false;
            return user.grants.some((g) => reaches(levelAt(user, resource, g.place, tree), "view"));
        }));
}
export function canAccessAtOwnPlaces(user, needs, nenda, tree) {
    const list = "resource" in needs ? [needs] : needs;
    return (list.length > 0 &&
        list.every(({ resource, level }) => {
            if (!isResourcePath(resource) || !isLevel(level))
                return false;
            return [nenda, ...user.grants.map((g) => g.place)].some((place) => reaches(levelAt(user, resource, place, tree), level));
        }));
}
export function userMayListAllPlacesUnder(user, resource, place, tree) {
    return reaches(levelAt(user, resource, place, tree), "view");
}
function grantAnswer(grant, resource) {
    var _a;
    const fromRole = grant.role === null
        ? null
        : isRoleName(grant.role)
            ? ROLES[grant.role].levels
            : {};
    for (const path of lookupOrder(resource)) {
        const level = (_a = personalLevel(grant, path)) !== null && _a !== void 0 ? _a : fromRole === null || fromRole === void 0 ? void 0 : fromRole[path];
        if (level)
            return level;
    }
    return fromRole ? "none" : undefined;
}
function personalLevel(grant, path) {
    let found;
    for (const setting of grant.personalLevels) {
        if (setting.resource !== path)
            continue;
        const level = isPersonalLevel(setting.level) ? setting.level : "none";
        found = found ? lowerOf(found, level) : level;
    }
    return found;
}
